import { getUserInfo } from './login'

var getLogData = function(vals) {
    const valArr = []
    for (var key in vals) {
        valArr.push(key + '=' + vals[key])
    }
    return valArr.join('&')
}

export const log = function(func, action, value) {
    const userInfo = getUserInfo()
    const params = {
        module: 'kj-peki',
        channel: 'h5',
        opt: userInfo ? userInfo.id : '-',
        action: action,
        function: func,
        value: encodeURIComponent(value),
        page: encodeURIComponent(window.location.href)
    }
    const logData = getLogData(params)
    var image = new Image()
    image.onload = image.onerror = image.onabort = function() {
        image = image.onload = image.onerror = image.onabort = null
    }
    image.src = '//api.peki.vip/cupid-api/blink/log?' + logData
}
